import { CustomerSegmentType } from 'src/stores/SsoStore';
import { Language } from '../../stores/LanguageStore';
import { FetchStatus } from '../../util/FetchStatus';

export type ErrorType = 'INVALID_ID' | 'REQUEST' | 'CANCELLED' | 'MISSING_ID';

export interface Reservation {
  id: string;
  encryptedReservationId?: string;
  branchId: number;
  reservationDate: string;
  stateCode: string;
  slotNumber: number;
  ticketNumber?: number;
}

export interface Branch {
  reservationsEnabled: boolean;
  branchId: number;
  name: string;
  type: BranchType;
  parentBranchId?: number;
  city?: BranchCity;
  additionalDescription?: TranslationMap;
  locationDescription?: TranslationMap;
  locationDescriptionLong?: TranslationMap;
  streetAddress?: TranslationMap;
  businessHours?: BusinessHour[];
  specialHours?: SpecialHour[];
  googleMapsLink?: string;
  accessibilityInformation?: string[];
}

interface BranchCity {
  cityName?: string;
}

export type TranslationMap = {
  [lang in Language]?: string;
};

export interface BusinessHour {
  openTime?: string;
  closeTime?: string;
  closed: boolean;
  startDay: string;
  endDay: string;
}

export interface SpecialHour {
  openTime?: string;
  closeTime?: string;
  closed: boolean;
  startDate: string;
  endDate: string;
}

export enum BranchType {
  TECH_STORE = 'TECH_STORE',
  STORE = 'STORE',
  CALL = 'CALL',
  B2B_STORE = 'B2B_STORE',
}

export interface BranchWithChild {
  parent: Branch;
  children?: Branch[];
}

export interface City {
  name: string;
  branches: Branch[];
}

export interface CitiesHolder {
  cities: City[];
  status: FetchStatus;
}

export interface CallbackCreation extends CallbackReservation {
  name: string;
  branchId: number;

  [key: string]: string | number;
}

export interface CallbackReservation {
  phone: string;
  email?: string;
  time: string;
  language?: string;
  name?: string;
  topic?: 'SERVICES' | 'BILLING' | 'SUPPORT';
  subjectContext?: CustomerSegmentType;
  customerId?: number;
  description?: string;

  [key: string]: string | number;
}

export interface ReservationCreationState {
  errors: ReservationError[];
  status: 'BEING_FILLED' | 'SUCCESS' | 'SENDING' | 'INVALID_INPUT' | 'ERROR' | 'PREVIEW' | 'VALIDATION_FAILED';
}

export interface ReservationCreation {
  phone: string;
  email?: string;
  time: string;
  language: string;
  customerId?: number;
  name?: string;
  description?: string;
  subjectContext?: CustomerSegmentType;
}

export interface ReservationError {
  code: string;
  message: string;
}

export enum ReservationCreationError {
  BAD_REQUEST = 400,
}

export interface AvailableReservation {
  time: string;
}

export interface AvailableCallbackReservationWrapper {
  availableReservations?: AvailableReservation[];
  status: string;
}

export interface InitialReservationCreation {
  customerId: number;
  name: string;
  firstName?: string;
  lastName?: string;
  phone?: string;
  segment?: CustomerSegmentType;
  customerDisplayName?: string;
  communicationLanguageCode?: string;
}

export const CALLBACK_BRANCHES_BY_LANG_TOPIC_SEGMENT: {
  [key: string]: { [key: string]: { [key: string]: number } };
} = {
  et: {
    SERVICES: {
      B2C: 1000,
      B2B: 1002,
    },
    BILLING: {
      B2C: 1000,
      B2B: 1002,
    },
    SUPPORT: {
      B2C: 1003,
      B2B: 1005,
    },
  },
  ru: {
    SERVICES: {
      B2C: 1001,
      B2B: 1002,
    },
    BILLING: {
      B2C: 1001,
      B2B: 1002,
    },
    SUPPORT: {
      B2C: 1004,
      B2B: 1006,
    },
  },
  en: {
    SERVICES: {
      B2C: 1008,
      B2B: 1002,
    },
    BILLING: {
      B2C: 1008,
      B2B: 1002,
    },
    SUPPORT: {
      B2C: 1007,
      B2B: 1006,
    },
  },
};
